import React from 'react';
import { visuallyHidden } from '@mui/utils';
import { Box, TableSortLabel } from '@mui/material';
import { MUIBaseEntity, MUITableHeaderWithSortProps } from './types';

export const MUITableHeaderWithSort = <TableEntity extends MUIBaseEntity>({
  column,
  sorting,
  isSorted,
}: MUITableHeaderWithSortProps<TableEntity>) => {
  const handleSort = () => {
    sorting.onChange({
      key: column.sortKey!,
      value: isSorted && sorting.value === 'asc' ? 'desc' : 'asc',
    });
  };

  return (
    <TableSortLabel active={isSorted} onClick={handleSort} direction={isSorted ? sorting.value : 'asc'}>
      {column.header}

      {isSorted && (
        <Box component="span" sx={visuallyHidden}>
          {sorting.value === 'desc' ? 'sorted descending' : 'sorted ascending'}
        </Box>
      )}
    </TableSortLabel>
  );
};
